import "./App.css";
import React from "react";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import Header from "./components/header/Header";
import Home from "./components/home/Home";
import About from "./components/about/About";
import Skills from "./components/skills/Skills";
import Qualification from "./components/qualification/Qualification";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import ScrollUp from "./components/scrollup/ScrollUp";
// import LocomotiveScroll from "locomotive-scroll";
// const scroll = new LocomotiveScroll();

function App() {
	return (
		<>
			<Header />

			<main className="main">
				<Home />
				<About />
				<Skills />
				<Qualification />
				<Contact />
			</main>
			<Footer />
			<ScrollUp />
			<Analytics />
			<SpeedInsights />
		</>
	);
}

export default App;
